export const CONTIKPRO_PUBLIC_URL = '';

export const contikProProductUrl = '/';
export const contikProDemoUrl = '/contikpro/demo/?demo=1&seed=contikpro';
export const contikProDownloadUrl = '/download/';
export const contikProMacIntelDownloadUrl = '/downloads/ContikPro-Core_2.0.0_x86_64-apple-darwin.dmg';
